@let propertyProfileHistory = propertyProfileHistory$ | async;

<red-header-content>
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-back-button defaultHref="/property-search"></ion-back-button>
    </ion-buttons>
    <ion-title>Profile History</ion-title>
  </ion-toolbar>
</red-header-content>
<red-page-content>
  <ion-refresher slot="fixed" [pullFactor]="0.5" [pullMin]="100" [pullMax]="200" (ionRefresh)="handleRefresh($event)">
    <ion-refresher-content
      class="tw:pt-10"
      pullingIcon="chevron-down-outline"
      pullingText="Pull down to refresh"
      refreshingText="Refreshing..."
    ></ion-refresher-content>
  </ion-refresher>

  @if (!propertyProfileHistory?.length) {
  <div class="tw:m-4 tw:text-xs">
    <ion-note color="medium">
      You have no saved property profile reports to display. Perform a profile search and come back here to view it.
    </ion-note>
  </div>
  }
  <ion-list [inset]="false" lines="full">
    @if (useMobileLayout$ | async) { @for (propertyProfileHistoryItem of propertyProfileHistory; track
    propertyProfileHistoryListTrackBy($index, propertyProfileHistoryItem)) {
    <ion-item-sliding>
      <ion-item [button]="true" (click)="loadProfileFromHistory(propertyProfileHistoryItem)">
        <ng-container
          [ngTemplateOutlet]="historyListItemLabel"
          [ngTemplateOutletContext]="{propertyProfileHistoryItem:propertyProfileHistoryItem}"
        >
        </ng-container>
      </ion-item>
      <ion-item-options>
        <ion-item-option color="danger" (click)="handleDelete($event, propertyProfileHistoryItem)">
          <ion-icon slot="icon-only" name="trash"></ion-icon>
        </ion-item-option>
      </ion-item-options>
    </ion-item-sliding>
    } } @else { @for (propertyProfileHistoryItem of propertyProfileHistory; track
    propertyProfileHistoryListTrackBy($index, propertyProfileHistoryItem)) {
    <ion-item [button]="true" (click)="loadProfileFromHistory(propertyProfileHistoryItem)">
      <ng-container
        [ngTemplateOutlet]="historyListItemLabel"
        [ngTemplateOutletContext]="{propertyProfileHistoryItem:propertyProfileHistoryItem}"
      >
      </ng-container>
      <ion-button slot="end" size="default" color="danger" (click)="handleDelete($event, propertyProfileHistoryItem)">
        <ion-icon slot="icon-only" name="trash"></ion-icon>
      </ion-button>
    </ion-item>
    } }
  </ion-list>
</red-page-content>

<ng-template #historyListItemLabel let-propertyProfileHistoryItemUntyped="propertyProfileHistoryItem">
  @let propertyProfileHistoryItem = asPropertyProfileHistoryItem(propertyProfileHistoryItemUntyped);
  <ion-label>
    <ion-text class="tw:text-sm tw:font-bold">{{ propertyProfileHistoryItem.reportDate | date:'MM/dd/yyyy' }}</ion-text
    ><br />
    <ion-text color="medium" class="tw:text-md tw:font-bold">
      {{ propertyProfileHistoryItem.displayStreetAddress | redDashIfEmpty }} </ion-text
    ><br />
    <ion-text color="medium" class="tw:text-md">
      {{ propertyProfileHistoryItem.displayCity | redDashIfEmpty }}, {{ propertyProfileHistoryItem.displayStateCode |
      redDashIfEmpty }} </ion-text
    ><br />
    <ion-text color="medium" class="tw:text-sm">
      {{ propertyProfileHistoryItem.displayOwnerNames | redDashIfEmpty }} </ion-text
    ><br />
  </ion-label>
</ng-template>
